import React, { useEffect } from 'react';
import {KitsAdvs} from '../../components/KitsAdvertisement';
import KitsCards from '../../components/KitsCards';
import ColumnedCards from '../../components/KitsColumnedCards';
import { Section } from '../../components/KitsSection'
import { PageWrapper } from '../../components/KitsSection/style'
import Slides from '../../components/KitsSlides';
import SmallTitle from '../../components/KitsSmallTitle';
import { DetailsTitle } from '../../components/DetailsTitle'
import OrangeLine from '../../components/OrangeLine';
import {section, section_title, section_small_title1, section_small_title2, section_small_title3, columned_cards, Slides as slidesProps, section_small_title_left, CardColumns, adsSection, BCT_Text1} from './data'
import styled from 'styled-components'
import ArrowedTitle from '../../components/ArrowedTitle';
import CenteredTextRow from '../../components/CenteredTextRow';

const NavbarPlaceholder = styled.div`
height: 80px;
width: 100%;
background-color: #212121;
`

export const MobilkitDetailsPage = () =>  {

    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])

    return (
        <>
        <NavbarPlaceholder/>
        <PageWrapper>
            <DetailsTitle {...section_title}/>
            <Section section={section}/>
            <SmallTitle props={section_small_title1}/>
            <SmallTitle props={section_small_title2}/>
            <ColumnedCards props={columned_cards}/>
            <SmallTitle props={section_small_title3}/>
            {/*<Slides props={slidesProps}/>*/}
            <SmallTitle props={section_small_title_left} />
            <KitsCards props={CardColumns} />
            <OrangeLine/>
            <CenteredTextRow props={BCT_Text1}/>
            <OrangeLine/>
            <ArrowedTitle text="Other KITs"/>
            <KitsAdvs props={adsSection} />
        </PageWrapper>
        </>
    )
}
